import { connect } from 'react-redux';

import { injectIntl } from 'react-intl';


import VersionHistorySidePanel from '../components/VersionHistorySidePanel';

const mapDispatchToProps = {};

const mapStateToProps = (state, props) => ({
  ...props,
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(VersionHistorySidePanel));
